export interface FormError {
  key: string;
  severity: Severity;
  type?: FormErrorType;
  messages: string[] | Message[];
}

export enum Severity {
  Debug = 'Debug',
  Info = 'Info',
  Error = 'Error',
}

export enum FormErrorType {
  Validation = 'Validation',
  Response = 'Response',
}

export type CustomValidator = (val: any) => string[];

export interface Message {
  index: number;
  id: string;
  message: string;
}